"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVERSED_CARD_ORDER = exports.SHORT_SUIT_VALUES = exports.SHORT_CARD_VALUES = exports.SUITS = exports.TWO_WINS_CARD_ORDER = exports.CARD_ORDER = void 0;
exports.CARD_ORDER = [
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    "jack",
    "queen",
    "king",
    "ace",
    2,
    "joker"
];
exports.TWO_WINS_CARD_ORDER = [
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    "jack",
    "queen",
    "king",
    "ace",
    "joker",
    2
];
exports.SUITS = ["spade", "heart", "club", "diamond"];
exports.SHORT_CARD_VALUES = exports.CARD_ORDER.slice(8);
exports.SHORT_SUIT_VALUES = exports.SUITS.slice(2);
exports.REVERSED_CARD_ORDER = [
    "ace",
    "king",
    "queen",
    "jack",
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    "joker"
];
//# sourceMappingURL=constants.js.map